import React, {useState} from 'react';
import Button from '@mui/material/Button';
import Alert from './Alert';
import {Owner,BookOption} from './Inc';
import Ajax from './Ajax';

interface Props {
    owner:Owner,
    option:BookOption,
    cache_key:string,
    update(option:BookOption):void,
}

let file:File;

const BookInputTab3 = (props:Props)=> {
    Ajax.setEditorId(props.owner.owner_id);
    const [states,setStates] = useState({
        toast: "",
        isFile: false,
        isLoading: false,
    });
    const changeFile = (event: React.ChangeEvent<HTMLInputElement>)=>{
        if( event.target.files ){
            file = event.target.files[0];
            setStates({...states,isFile:true});
            //console.log( file );
        }
    }
    const uploadFile = ()=>{
        setStates({...states,isLoading:true})
        Ajax.upload("book/upload",{file:file,cache_key:props.cache_key},(res:any)=>{
            if( res.ok ){
                props.update(props.option);
            } else {
                //console.log(res);
                setStates({...states,isLoading:false,toast:"アップロードできませんでした。"+res.error})
            }
        });
    }
    const closeToast = ()=>{
        setStates({...states,toast:""});
    }

    return (
        <div id="book_input_tab3">
            <div id="tab3" className="bookTab">
                <div className="upload">
                    <input type="file" onChange={changeFile}/>
                    {states.isFile &&
                    <div className="upload_btn">
                        <Button variant="outlined" color="primary" onClick={uploadFile} style={{width:"100%"}}>アップロード</Button>
                    </div>
                    }
                </div>
                <div className="talk">
                    <p>原稿ファイルをアップロードします。</p>
                </div>
                <ul className="bookHint">
                    <li>セリフとト書きの判別や不要な行の削除、改行の調整等は「一括編集」や「微調整」で行います。</li>
                    <li>アップロードできるファイルは以下の2種類だけです。<br/>
                        ・ワード（.docx）<br/>
                        ・テキスト（.txt）<br/>
                    </li>
                    <li>以下の内容を原稿に含める必要はありません。
                        <ul>
                            <li>表紙</li>
                            <li>タイトル</li>
                            <li>サブタイトル</li>
                            <li>作者名</li>
                            <li>団体名</li>
                            <li>登場人物一覧</li>
                            <li>上演記録</li>
                            <li>作品の紹介文</li>
                            <li>あらすじ</li>
                            <li>価格</li>
                            <li>上演時間の目安</li>
                            <li>役者人数の目安</li>
                            <li>上演許可の有無</li>
                        </ul>
                    </li>
                </ul>
            </div>
            <Alert close={closeToast} mes={states.toast} isOpen={states.toast!==""}/>
        </div>
	);
}

export default BookInputTab3;
